import { Button, Checkbox, FormControlLabel, Icon, IconButton, List, ListItemSecondaryAction, ListItemText, Menu, MenuItem, ListSubheader, ListItemIcon } from '@mui/material';
import { ImageList } from 'global/components/image';
import { CenterContent, GridContainer, LeftSideBar, RightSideBar } from 'global/components/perform-grid';
import withInfiniteScroll from 'global/components/withInfiniteScroll';
import useRetrieveData from 'global/hooks/useRetrieveData';
import useAccessRedirect from 'global/hooks/useAccessRedirect';
import { useVendors } from 'global/hooks/useVendors';
import { first, get, last, orderBy, set, size, uniqBy, unset } from 'global/lib/lodash';
import { Loading, useScreen } from 'global/styles';
import { getTaskImage, getTaskStatus, getTaskTradeTypes, getUrlParams } from 'global/utils';
import { buildFilters } from 'global/utils/filter';
import realmChange from 'global/wrappers/realmChange';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, withRouter } from 'react-router-dom';
import { userHasPermissions } from 'redux/actions/userLogin';
import setUserRealm from 'redux/actions/userRealm';
import { addNewTask, removeNewTask, setTaskList } from 'redux/actions/view';
import Modal from '../../../global/components/modal';
import { MoreList } from '../../../global/components/more-drop';
import { Row } from '../../../global/components/row';
import { Text } from '../../../global/components/text';
import { useView } from '../../../global/hooks/useView';
import { stopProp, taskNumToString, taskStringToNum } from '../../../global/utils';
import TaskFilters from '../Filters';
import TaskCreate from '../TaskCreate';
import { RenderTag } from '../TaskCreate/TaskCreate';
import { DetailModal } from '../TaskDetail';
import { CommentContainer } from '../TaskDetail/comments';
import MessageListItem from '../TaskList/MessageListItem';
import TaskListItem from '../TaskList/TaskListItem';
import TaskNotify from '../TaskNotify';
import {
  ExpandContainer,
  FlexRow,
  HeaderRow,
  ImageIcon,
  ItemContainer,
  LeftIconWrap,
  NoPaddingList,
  Pad,
  PadLeftRow,
  PadRow,
  SecondaryActionWrap,
  TagContainer,
  TaskRealmButton,
  TextRow,
  ImageRow,
} from './TaskRealm.styles';
import { useTaskTypes } from '../task-type-utils/useTaskTypes';
import { getAvailableTaskTypes, getAvailableTaskTypesForTier, getTaskTypeById, getTaskTypeIcon, getTaskTypeIdFromTask, groupTaskTypesByMode } from '../task-type-utils';

const include =
  'images,realm,authors,assignees,comments,scorecardScore,scorecardScore.checklist,scorecardScore.checkpoint,subScore,subScore.scorecardScore,tradeTypes';
const pageSize = 200;

// Persist selected task type IDs across realm navigation (component remounts)
let _persistedTypeIds = [];

const getCommentText = (task) => {
  const commCount = size(task.comments);
  const dueDate = get(task, 'dueDate');

  let str = '';
  let dueText = null;

  if (commCount > 0) {
    const lastComm = last(task.comments);
    const time = moment(lastComm.updatedAt).fromNow();
    str = `${commCount} comment${commCount > 1 ? 's' : ''} - ${time}`;
  } else {
    str = 'No comments';
  }

  if (dueDate && task.status != taskStringToNum('closed')) {
    const now = moment().endOf('day');
    const ddate = moment(first(dueDate.split('T'))).endOf('day');
    const isDue = ddate.diff(now, 'hours') < 0;
    dueText = (
      <Text type="label_small" italic bold style={isDue ? { color: 'red', marginLeft: 3 } : { marginLeft: 3 }}>
        {isDue ? ` Overdue: ${ddate.fromNow()}` : `Due: ${ddate.fromNow()}`}
      </Text>
    );
  }

  return (
    <Row>
      <Text type="label_small" italic>
        {str}
        {dueText ? ' -' : ''}
      </Text>
      {dueText}
    </Row>
  );
};

export const StatusDrop = (props) => {
  const { item } = props;

  const showDropIcon = get(props, 'showDropIcon', true);

  const options = [
    { title: 'Open', value: 0 },
    { title: 'Pending', value: 1 },
    { title: 'Closed', value: 2 },
  ].map((v) => ({ ...v, selected: get(item, 'status') == v.value, onClick: (e) => props.onSelect(e, v) }));

  return (
    <div style={{ marginBottom: 4 }}>
      <MoreList
        {...props}
        variant="outlined"
        color="secondary"
        onOpen={() => props.onOpen && props.onOpen()}
        onClose={() => props.onClose && props.onClose()}
        buttonProps={{ disabled: props.readOnly, style: { padding: `0px 10px` } }}
        showIcon={false}
        options={options}
        renderButton={() => (
          <Row>
            {getTaskStatus(item).titleCase}
            {showDropIcon && <Icon style={{ marginLeft: 5 }}>arrow_drop_down</Icon>}
          </Row>
        )}
      />
    </div>
  );
};

const TaskItem = withRouter((props) => {
  const { item, expanded } = props;
  const task = item;
  const [tag, setTag] = useState();
  const itemTaskType = getTaskTypeById(props.taskTypesData || [], getTaskTypeIdFromTask(task));
  const image = getTaskImage(task);
  const commText = getCommentText(task);
  const tradeTypes = getTaskTradeTypes(task);
  const newTasks = useSelector((state) => get(state, 'view.task.new'));
  const dispatch = useDispatch();
  const isSelected = !!newTasks.find((t) => t.id === task.id);
  const [modalOpen, setModalOpen] = useState(false);
  const [taskDetail, setTaskDetail] = useState({
    open: false,
    useHistory: false,
  });
  const [quickEdit, setQuickEdit] = useState({
    open: false,
  });
  const [moreOpen, setMoreOpen] = useState(false);

  const closeItemTaskDetail = () => {
    setTaskDetail((s) => ({ ...s, open: false }));
    props.onCloseDetail?.();
  };

  const closeQuickEdit = () => {
    setQuickEdit((s) => ({ ...s, open: false }));
    props.onCloseDetail?.();
  };

  const onCheckChange = (e) => {
    // stopPropagation only. preventDefault cancels the checkbox activation, so
    // onChange never fires and the row stays unselected.
    e.stopPropagation();

    if (isSelected) {
      dispatch(removeNewTask(task));
    } else {
      dispatch(addNewTask({ ...task, fromSelected: true }));
    }
  };

  const renderIcon = () => (
    <LeftIconWrap onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
      <Checkbox size="small" checked={isSelected} onChange={onCheckChange} onClick={(e) => e.stopPropagation()} />
    </LeftIconWrap>
  );

  const d = item;

  const scorecardId = expanded ? get(d, 'scorecardScore.scorecardId', get(d, 'subScore.scorecardScore.scorecardId', null)) : null;
  const scData = useRetrieveData(
    { url: `/scorecards/${scorecardId}` },
    {
      useCache: { reload: 20 },
      waitFor: scorecardId,
      build: ['scorecards'],
    }
  );
  const scorecard = get(scData, 'data.0');
  const scorecardConfig = get(scData, 'data.0.config');

  const clickItem = () => {
    if (moreOpen) {
      return;
    }

    setTaskDetail((s) => ({
      ...s,
      taskId: item.id,
      open: true,
    }));
  };

  useEffect(() => {
    if (d) {
      if (get(d, 'scorecardScore')) {
        const scs = get(d, 'scorecardScore');
        const cp = get(scs, 'checkpoint');

        setTag({
          scorecardConfig: scorecardConfig,
          ...cp,
          ...scs,
        });
      } else if (get(d, 'subScore')) {
        const { subScore, ...rest } = d;
        setTag({
          ...rest,
          scorecardConfig: scorecardConfig,
          ...get(subScore, 'scorecardScore', {}),
          ...subScore,
        });
      } else {
        setTag();
      }
    }
  }, [d, scorecard]);

  const showRowImages = (image.src || image.icon) && !expanded;

  const handleSelection = (e, selected) => {
    stopProp(e);
    setQuickEdit((q) => ({ ...q, open: true, item: { ...props, task }, selected, taskType: itemTaskType }));
  };

  const diplayImages = item.images.map((img) => {
    return {
      ...img,
      task,
    };
  });

  return (
      <ItemContainer
      disableRipple={props.readOnly || !!quickEdit.open || !!modalOpen || !!taskDetail.open || moreOpen}
      key={task.id}
      component={null}
      button
      disableGutters
      alignItems={'flex-start'}
      readOnly={props.readOnly}
      withImage={showRowImages}
      data-testid="task-list-item"
    >
      <FlexRow onClick={clickItem}>
        {renderIcon()}
        <ListItemText
          primary={
            <FlexRow as="div">
              {itemTaskType && <Icon fontSize="small" style={{ marginRight: 4, opacity: 0.6 }}>{getTaskTypeIcon(itemTaskType)}</Icon>}
              <div className={'Title'} data-testid="task-list-item-title">{task.name}</div>
            </FlexRow>
          }
          secondary={
            <div className="TextRowContainer">
              <div className="traderow" data-testid="task-list-item-trades">{tradeTypes ? tradeTypes.map((t) => <span>{t}</span>) : 'None'}</div>
              <TextRow>{get(task, 'description') || ''}</TextRow>
              <div className="daterow">{`${get(task, 'authors.0.name')} - ${moment(task.createdAt).fromNow()}`}</div>
              <div className="daterow">{commText}</div>
            </div>
          }
        />
        <ListItemSecondaryAction>
          <SecondaryActionWrap>
            <StatusDrop item={item} onOpen={() => setMoreOpen(true)} onClose={() => setMoreOpen(false)} onSelect={(e, v) => handleSelection(e, v)} readOnly={props.readOnly} />
            {showRowImages && (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                {image.src && <ImageList images={diplayImages} displayAmt={1} showCaption={false} onOpen={() => setModalOpen(true)} onClose={() => setModalOpen(false)} spaceBetween={5} />}
                {image.icon && <ImageIcon as={Icon}>{image.icon}</ImageIcon>}
              </div>
            )}
          </SecondaryActionWrap>
        </ListItemSecondaryAction>
      </FlexRow>
      {expanded && (
        <ExpandContainer>
          {!tag && <Pad />}
          {tag && (
            <TagContainer>
              <RenderTag tag={tag} showLink={false}/>
            </TagContainer>
          )}
          <ImageRow>
            <ImageList images={diplayImages} onOpen={() => setModalOpen(true)} onClose={() => setModalOpen(false)} spaceBetween={5} />
          </ImageRow>
        </ExpandContainer>
      )}
      <DetailModal {...taskDetail} onClose={closeItemTaskDetail} />
      <QuickEditModal {...quickEdit} onClose={closeQuickEdit} />
    </ItemContainer>
  );
});

export const QuickEditModal = (props) => {
  if (!props.open) {
    return null;
  }

  return (
    <Modal {...props} maxWidth={'80%'} title="Status Change">
      <div>
        <TaskItem {...props.item} readOnly />
        <CommentContainer {...props} {...props.item.item} isModal task={get(props, 'item.task')} taskType={get(props, 'taskType')} showComments={false} openInCreate={{ newStatus: taskNumToString(get(props, 'selected.value')), showToggle: true }} />
      </div>
    </Modal>
  );
};

export default withRouter(
  realmChange((props) => {
    const { match } = props;
    const [showCreate, setShowCreate] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [typeMenuAnchor, setTypeMenuAnchor] = useState(null);
    const [selectedTaskType, setSelectedTaskType] = useState(null);
    const { data: taskTypesData } = useTaskTypes();
    const filter = useSelector((state) => get(state, 'filter.tasks.realm'));
    const newTasks = useSelector((state) => get(state, 'view.task.new'));
    const globalRealm = useSelector((state) => get(state, 'auth.realm'));
    const [showMessages, setShowMessages] = useState(false);
    const dispatch = useDispatch();
    const vendors = useVendors(undefined, { includeUsersRealm: true, include: 'vendor' });
    const [hstate, sethState] = useState({
      selectAll: false,
      history: false,
      sort: 'modified',
      filter: {
        // status: undefined,
      },
    });
    const [data, setData] = useState([]);
    const [mdata, setMData] = useState([]);
    const [selectedTypeIds, _setSelectedTypeIds] = useState(_persistedTypeIds);
    const setSelectedTypeIds = (valOrFn) => {
      _setSelectedTypeIds((prev) => {
        const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
        _persistedTypeIds = next;
        return next;
      });
    };
    const { addNewTasks, removeNewTasks, view } = useView();

    const { isMobile } = useScreen();

    const id = get(match, 'params.id', 0);

    const [messageParams, setMessageParams] = useState({ waitFor: null });
    const [urlParams, setUrlParams] = useState({ waitFor: null });

    const sortOptions = [
      !showMessages && { title: 'Updated', value: 'modified', sort: (d) => orderBy(d, 'updatedAt', 'desc') },
      { title: 'Newest', value: 'date_created', sort: (d) => orderBy(d, 'createdAt', 'desc') },
      { title: 'Oldest', value: 'date_oldest', sort: (d) => orderBy(d, 'createdAt') },
      !showMessages && { title: 'Due Date', value: 'due_date', sort: (d) => orderBy(d, 'dueDate') },
      !showMessages && {
        title: 'Trade Type',
        value: 'tradeType',
        sort: (d) => orderBy(d, (i) => (get(i, 'tradeTypes.0.name') || get(i, 'tradeTypes.0.defaultName') || 'zzz').toLowerCase()),
      },
    ].filter((f) => !!f);

    const taskCountItem = useRetrieveData(
      { url: `/processed-task-count-values/${id}` },
      { build: ['processedTaskCountValues'], transformData: (d) => get(d, 0), params: { include: 'realm,realm.parent' } }
    );
    const item = get(taskCountItem, 'data');

    // PFM-2565: redirect to /tasks/list when this task-count entry is inaccessible / does not exist.
    useAccessRedirect(taskCountItem, { skip: !id });
    const realmTier = get(item, 'realm.tier');
    const availableTaskTypes = useMemo(
      () => getAvailableTaskTypesForTier(getAvailableTaskTypes(taskTypesData), realmTier),
      [taskTypesData, realmTier]
    );
    const availableTypeIdsKey = useMemo(() => availableTaskTypes.map((tt) => String(tt.id)).join(','), [availableTaskTypes]);

    useEffect(() => {
      if (!realmTier) return; // data not loaded yet, don't prune
      const ids = availableTypeIdsKey.split(',').filter(Boolean);
      setSelectedTypeIds((prev) => {
        const pruned = prev.filter((id) => ids.includes(id));
        return pruned.length === prev.length ? prev : pruned;
      });
    }, [availableTypeIdsKey, realmTier]);

    const loca = useLocation();
    const { realmId } = getUrlParams(loca.search);
    const _realmId = get(item, 'realm.id') || realmId;
    const isMy = get(filter, 'ownership') === 'my';

    const filterProps = (type) => {
      if (type === 'message') {
        return {
          include: 'realm,from,model,media,users',
          ...{ page: { size: pageSize, number: 1 } },
          ...buildFilters(
            {
              ...filter,
              realm: _realmId,
              _sort: {
                sortBy: '-created_at',
              },
            },
            {
              includeRealm: false,
              dontFilter: ['name', 'content', 'searchstring', 'ownership', 'status', 'vendor_id', 'age'],
              dontSort: ['-open', '-pending', 'updated_at', 'oldest', 'count'],
            }
          ),
        };
      } else {
        return {
          include,
          ...{ page: undefined },
          ...buildFilters(filter, {
            includeRealm: false,
            convertName: { searchstring: 'name', realm_type: 'tier' },
            dontFilter: ['content', 'name'],
            overrideFilter: (filtObj) => {
              if (filtObj.status) {
                set(filtObj, filtObj.status, true);
                delete filtObj.status;
              }
              if (filtObj.vendor_id === 0) {
                delete filtObj.vendor_id;
              }
              set(filtObj, 'onlyRealm', _realmId);
              return filtObj;
            },
            overrideSort: (sort) => {
              return undefined;
            },
          }),
        };
      }
    };

    useEffect(() => {
      if (!_realmId) {
        return;
      }

      setMessageParams({
        build: ['messages'],
        useEffect: true,
        waitFor: showMessages,
        params: filterProps('message'),
      });
      setUrlParams({
        build: ['tasks'],
        useEffect: true,
        waitFor: undefined,
        params: filterProps(),
      });
    }, [filter, _realmId, showMessages]);

    const { data: _data, loading, update, meta } = useRetrieveData({ url: `/tasks` }, urlParams);
    const messages = useRetrieveData({ url: '/messages' }, messageParams);

    const clearDetailParam = () => {
      const search = new URLSearchParams(loca.search);
      search.delete('detail');
      props.history.replace(`${loca.pathname}?${search.toString()}`);
    };

    const [taskDetail, setTaskDetail] = useState({
      open: false,
      useHistory: false,
    });

    const closeTaskDetail = () => {
      setTaskDetail((s) => ({ ...s, open: false }));
      clearDetailParam();
      update();
    };

    useEffect(() => {
      if (taskCountItem.loading) {
        return;
      }

      messages.update();
    }, [newTasks]);

    useEffect(() => {
      dispatch(setTaskList(data));
    }, [data]);

    useEffect(() => {
      const { detail } = getUrlParams(loca.search);
      if (detail) {
        // PFM-2686: a `detail` param present at mount means the page was opened/refreshed
        // straight onto a task (in-session clicks clear it again on close), so flag it as
        // restoredFromUrl. TaskDetail uses that to align the list filters to the task
        // (My Tasks unless not owned; Closed if the task is closed) so the underlying list
        // still shows it after the modal closes.
        setTaskDetail((s) => ({ ...s, open: true, taskId: detail, restoredFromUrl: true }));
      }
    }, []);

    useEffect(() => {
      sethState((h) => ({ ...h, sort: showMessages ? 'date_created' : 'modified' }));
    }, [showMessages]);

    useEffect(() => {
      const dd = uniqBy(showMessages ? messages.data : _data, 'id');
      const hasFilter = Object.hasOwn(hstate.filter, 'status');

      let filteredData =
        !hasFilter || showMessages
          ? dd
          : dd.filter((d) => {
              return size(
                Object.keys(hstate.filter).filter((k) => {
                  const val = hstate.filter[k];
                  return get(d, k) == val;
                })
              );
            });

      // Client-side task type filtering
      if (!showMessages && size(selectedTypeIds)) {
        filteredData = filteredData.filter((d) => {
          const typeId = String(getTaskTypeIdFromTask(d) || '');
          return selectedTypeIds.includes(typeId);
        });
      }

      const selSort = sortOptions.find((s) => s.value == hstate.sort);

      const meth = showMessages ? setMData : setData;
      meth(selSort.sort(filteredData));
    }, [_data, messages.data, hstate.sort, hstate.filter, selectedTypeIds]);

    useEffect(() => {
      if (hstate.selectAll) {
        addNewTasks(data.map((d) => ({ ...d, fromSelected: true })));
      } else {
        const hasNew = get(view, 'task.new', []).find((t) => !t.fromSelected);
        if (hasNew) {
          return;
        }
        removeNewTasks();
      }
    }, [hstate.selectAll]);

    const toggleMessages = async () => {
      setShowMessages(!showMessages);
    };

    const lastPageMessages = get(messages.meta, 'page.last-page', null);
    const lastPageTasks = get(meta, 'page.last-page', null);
    const updatePage = (newPage, params) => {
      if (params === 'messages') {
        if (newPage <= lastPageMessages) {
          setMessageParams({
            ...messageParams,
            params: {
              ...messageParams.params,
              page: { size: pageSize, number: newPage },
            },
          });
        }
      } else if (params === 'tasks') {
        if (newPage <= lastPageTasks) {
          setUrlParams({
            ...urlParams,
            params: {
              ...urlParams.params,
              page: { size: pageSize, number: newPage },
            },
          });
        }
      }
    };

    const getItemOverride = () => {
      const obj = {
        ...item,
        open: 0,
        pending: 0,
        closed: 0,
      };

      if (loading) {
        obj.open = Loading;
        obj.pending = Loading;
        obj.closed = Loading;
      } else {
        _data.map((di) => {
          if (di.status === 0) {
            obj.open += 1;
          } else if (di.status === 1) {
            obj.pending += 1;
          } else if (di.status === 2) {
            obj.closed += 1;
          }
        });
      }

      return obj;
    };

    const changeFilter = (f, key = 'status') => {
      sethState((h) => {
        const filt = { ...h.filter };
        const val = taskStringToNum(f);
        const alreadyHasFilter = get(filt, key) == val;

        if (alreadyHasFilter) {
          unset(filt, key);
        } else {
          set(filt, key, val);
        }

        return {
          ...h,
          filter: { ...filt },
        };
      });
    };

    const renderHeader = () => {
      return (
        <HeaderRow as={Row}>
          <div className="div1">
            <FormControlLabel
              size="small"
              control={
                <Checkbox
                  disabled={showMessages}
                  size="small"
                  checked={!!hstate.selectAll}
                  onChange={(e) => sethState((s) => ({ ...s, selectAll: e.target.checked }))}
                />
              }
              label="Select All"
            />
          </div>

          {size(availableTaskTypes) > 1 && (
            <div className="typeFilters">
              {availableTaskTypes.map((tt) => {
                const isActive = selectedTypeIds.includes(String(tt.id));
                return (
                  <IconButton
                    key={tt.id}
                    size="small"
                    color={isActive ? 'primary' : 'default'}
                    style={{ opacity: isActive ? 1 : 0.4 }}
                    title={tt.name}
                    onClick={() => {
                      setSelectedTypeIds((prev) => {
                        const id = String(tt.id);
                        return prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id];
                      });
                    }}
                  >
                    <Icon fontSize="small">{getTaskTypeIcon(tt)}</Icon>
                  </IconButton>
                );
              })}
            </div>
          )}

          <Row className="div2">
            <IconButton color={showMessages ? 'primary' : undefined} onClick={toggleMessages}>
              <Icon>history</Icon>
            </IconButton>
            <IconButton disabled={showMessages} color={expanded ? 'primary' : undefined} onClick={() => setExpanded(!expanded)}>
              <Icon>unfold_more</Icon>
            </IconButton>
            <MoreList
              variant="outlined"
              color="secondary"
              showIcon={false}
              options={sortOptions.map((s) => ({ ...s, selected: get(hstate, 'sort') == s.value, onClick: (e, sel) => sethState((h) => ({ ...h, sort: s.value })) }))}
              renderButton={() => (
                <Row>
                  Sort By<Icon>import_export</Icon>
                </Row>
              )}
            />
          </Row>
        </HeaderRow>
      );
    };

    return (
      <GridContainer>
        <LeftSideBar hidden={isMobile}>
          <TaskFilters display={'realm'} vendors={vendors} />
        </LeftSideBar>

        <CenterContent overflowHidden={true}>
          <TaskNotify realmId={_realmId} />
          {isMobile && (
            <PadRow>
              <TaskFilters display={'realm'} vendors={vendors} />
            </PadRow>
          )}
          {item && (
            <NoPaddingList as={List}>
              <TaskListItem
                {...hstate}
                changeFilter={changeFilter}
                destination={`/tasks/list`}
                item={taskCountItem.data}
                itemOverride={isMy && getItemOverride()}
                isHeader={true}
                onClick={() => {
                  // Leaving a Lot via the header would otherwise bounce back in, because
                  // a Lot global location still auto-navigates to its single list row.
                  if (
                    get(globalRealm, 'tier') === 'lot' &&
                    String(get(globalRealm, 'id')) === String(get(item, 'realm.id'))
                  ) {
                    dispatch(setUserRealm(null));
                  }
                }}
              />
              <PadLeftRow>
                <TaskRealmButton as={Button}
                  data-testid={"tasks-location-task-create-button"}
                  disabled={!userHasPermissions('createTasks')}
                  variant="contained"
                  color="secondary"
                  onClick={(e) => {
                    if (size(availableTaskTypes) > 1) {
                      setTypeMenuAnchor(e.currentTarget);
                    } else if (size(availableTaskTypes) === 1) {
                      setSelectedTaskType(availableTaskTypes[0]);
                      setShowCreate(true);
                    } else {
                      setShowCreate(true);
                    }
                  }}
                  startIcon={<Icon>add</Icon>}
                  endIcon={size(availableTaskTypes) > 1 ? <Icon>arrow_drop_down</Icon> : undefined}
                >
                  {size(availableTaskTypes) === 1 ? `ADD ${(availableTaskTypes[0].name || '').toUpperCase()}` : 'ADD NEW'}
                </TaskRealmButton>
                <Menu
                  anchorEl={typeMenuAnchor}
                  open={Boolean(typeMenuAnchor)}
                  onClose={() => setTypeMenuAnchor(null)}
                >
                  {(() => {
                    const typeGroups = groupTaskTypesByMode(availableTaskTypes);
                    const renderItem = (tt) => (
                      <MenuItem
                        data-testid={`tasks-location-task-create-button-menu-${tt.id}`}
                        key={tt.id}
                        onClick={() => {
                          setSelectedTaskType(tt);
                          setShowCreate(true);
                          setTypeMenuAnchor(null);
                        }}
                      >
                        <ListItemIcon sx={{ minWidth: 32 }}>
                          <Icon fontSize="small">{getTaskTypeIcon(tt)}</Icon>
                        </ListItemIcon>
                        <ListItemText>{(tt.name || '').toUpperCase()}</ListItemText>
                      </MenuItem>
                    );
                    if (typeGroups.grouped) {
                      return typeGroups.groups.flatMap((group) => [
                        <ListSubheader key={group.label} sx={{ lineHeight: '32px', fontSize: 12 }}>
                          {group.label}
                        </ListSubheader>,
                        ...group.items.map(renderItem),
                      ]);
                    }
                    return availableTaskTypes.map(renderItem);
                  })()}
                </Menu>
              </PadLeftRow>
            </NoPaddingList>
          )}

          {showMessages && (
            <MessagesList
              handlePageChange={(np) => updatePage(np, 'messages')}
              currentPage={get(messageParams, 'params.page.number', 1)}
              lastPage={lastPageMessages}
              data={mdata || []}
              alwaysReplaceData
              loading={messages.loading}
              header={renderHeader()}
              isMobile={isMobile}
            />
          )}

          {!showMessages && (
            <TaskList
              handlePageChange={(np) => updatePage(np, 'tasks')}
              currentPage={get(urlParams, 'params.page.number', 1)}
              lastPage={lastPageTasks}
              data={data || []}
              alwaysReplaceData
              loading={loading}
              trackChecks={newTasks}
              expanded={expanded}
              tcid={id}
              header={renderHeader()}
              isMobile={isMobile}
              taskTypesData={taskTypesData}
              onCloseDetail={() => {
                clearDetailParam();
                update();
              }}
              {...hstate}
            />
          )}

          {showCreate && (
            <TaskCreate
              open={showCreate}
              taskType={selectedTaskType}
              onClose={() => {
                update();
                setShowCreate(false);
                setSelectedTaskType(null);
              }}
              realmItem={{
                realmName: get(item, 'realmName', ''),
                realm: {
                  id: _realmId,
                },
              }}
            />
          )}

          <DetailModal {...taskDetail} onClose={closeTaskDetail} />
        </CenterContent>
        <RightSideBar />
      </GridContainer>
    );
  })
);

const MessagesList = withInfiniteScroll(MessageListItem, List);
const TaskList = withInfiniteScroll(TaskItem, List);
